import { render, staticRenderFns } from "./BDzh.vue?vue&type=template&id=0ef991c9&scoped=true"
import script from "./BDzh.vue?vue&type=script&lang=js"
export * from "./BDzh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef991c9",
  null
  
)

export default component.exports